module.exports = __webpack_public_path__ + "static/media/attachment.7f9ea458.svg";